import type {
	RovoTargetingAudienceStatus,
	RovoTargetingReason,
	RovoTargetingSignal,
} from './eligibility';

export type RovoTargetingProductKey = 'confluence' | 'jira' | 'jsm';

export const isRovoTargetingProductKey = (
	productKey: string,
): productKey is RovoTargetingProductKey =>
	productKey === 'confluence' || productKey === 'jira' || productKey === 'jsm';

export type RovoTargetingAudienceEvent = {
	type: 'sendOperationalEvent';
	data: {
		source: 'rovoTargeting';
		action: 'evaluated';
		actionSubject: 'rovoTargeting';
		attributes: {
			outcome: Exclude<RovoTargetingAudienceStatus, 'loading'>;
			rollout: 'enabled' | 'disabled';
			definitionVersion: 'v1';
			signal: RovoTargetingSignal;
			reason: RovoTargetingReason;
			durationMs?: number;
		};
	};
};
export type RovoTargetingOperationalEventHandler = (event: RovoTargetingAudienceEvent) => void;

export type AudienceScope = {
	productKey: string;
	accountId?: string;
	siteId?: string;
	hasRovoAccess: boolean;
	gateEnabled: boolean;
};

export type AudienceSnapshot = {
	scopeKey: string;
	phase: 'loading' | 'ready' | 'unavailable' | 'outsideRollout';
	activeDays?: unknown;
	lastActive?: unknown;
	evaluatedAt?: number;
};

export type AudienceScopeContextValue = AudienceScope & { scopeKey: string };
